import { CustomerIntakeForm } from '../types/CustomerIntakeForm';

export const isCustomerProfileValid = (form: CustomerIntakeForm): boolean => !!(
  form.name
  && form.sector
  && form.operatingModel
  && form.owner
  && form.sitesCount !== ''
  && form.targetGoLive
);

export const isServiceRequirementsValid = (form: CustomerIntakeForm): boolean => !!(
  form.userTypes.length > 0
  && form.serviceTimes.length > 0
  && form.dietaryRequirements.length > 0
  && form.allergens.length > 0
);

export const isCommercialComplianceValid = (form: CustomerIntakeForm): boolean => !!(
  form.budget
  && form.pricingModel
  && form.complianceExpectations.length > 0
  && form.reportingRequirements.length > 0
);
